module.exports = __webpack_public_path__ + "static/img/5.b133532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/5.png
// module id = P/3A
// module chunks = 0